"use client";
import { Logo, Card, Heading, Text } from "@xenithlabs/xenith-ui";

export function MagicSent({ email }: { email: string }) {
  return (
    <div className="flex items-center justify-center w-screen h-screen bg-bg-default">
      <Logo className="absolute top-4 left-4" />
      <div className="grid w-full place-items-center">
        <Card className="w-[500px] h-[180px] shadow-md flex flex-col items-center justify-center">
          <Heading variant="h2" className="mb-2 text-center">
            An email is on its way!
          </Heading>
          <Text variant="regular" className="text-center text-text-weak mb-1">
            We sent an email to <b>{email}</b>. Check your inbox for the magic
            link that will sign you into the dashboard.
          </Text>
          <Text variant="tiny" className="text-center text-text-weak mt-2">
            The link will expire in <b>15 minutes</b>, so be sure to use it
            soon.
          </Text>
        </Card>
      </div>
    </div>
  );
}
